// Snippet caricato da piu' sezioni: il file puo' essere eseguito piu' volte
// nello stesso documento, quindi tutto il modulo va dentro un guard.
if (!customElements.get('tk-slider')) {
  class TkSlider extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.tk-slider__list');
      this.slides = Array.from(this.querySelectorAll('.tk-slider__slide'));
      this.prevButton = this.querySelector('[name="previous"]');
      this.nextButton = this.querySelector('[name="next"]');
      this.counterCurrent = this.querySelector('.slider-counter--current');
      this.counterTotal = this.querySelector('.slider-counter--total');

      if (!this.list || this.slides.length === 0) return;

      // Spostare la sezione nell'editor riconnette la stessa istanza:
      // senza guard i listener si ri-registrano a ogni reconnect.
      if (this.initialized) return;
      this.initialized = true;

      this.prevButton?.addEventListener('click', () => this.advance(-1));
      this.nextButton?.addEventListener('click', () => this.advance(1));

      // Counter + disabled state aggiornati su scrollend (debounce naturale).
      // Fallback a scroll + rAF per browser senza scrollend (Safari < 17, Firefox < 109).
      if ('onscrollend' in window) {
        this.list.addEventListener('scrollend', () => this.update());
      } else {
        let raf;
        this.list.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.update());
        });
      }

      // Tab dentro card off-screen → la porta in vista, ma solo sull'asse
      // orizzontale del list. scrollIntoView() agirebbe anche sull'asse block,
      // scrollando la pagina su/giu' quando la card e' a cavallo del bordo
      // verticale del viewport (jump intermittente segnalato durante lo scroll).
      this.slides.forEach((slide) => {
        slide.addEventListener('focusin', () => {
          const slideRect = slide.getBoundingClientRect();
          const listRect = this.list.getBoundingClientRect();
          let delta = 0;
          if (slideRect.left < listRect.left) delta = slideRect.left - listRect.left;
          else if (slideRect.right > listRect.right) delta = slideRect.right - listRect.right;
          if (delta !== 0) this.list.scrollBy({ left: delta, behavior: 'smooth' });
        });
      });

      if (this.counterTotal) this.counterTotal.textContent = this.slides.length;
      this.update();
    }

    get visibleSlides() {
      return this.slides.filter((s) => s.offsetParent !== null);
    }

    get slideStep() {
      const visible = this.visibleSlides;
      if (visible.length < 2) return visible[0]?.clientWidth || 0;
      return visible[1].offsetLeft - visible[0].offsetLeft;
    }

    get currentIndex() {
      const step = this.slideStep;
      return step > 0 ? Math.round(this.list.scrollLeft / step) : 0;
    }

    advance(direction) {
      const target = Math.max(0, Math.min(this.slides.length - 1, this.currentIndex + direction));
      this.list.scrollTo({ left: target * this.slideStep, behavior: 'smooth' });
    }

    update() {
      const idx = this.currentIndex;
      if (this.counterCurrent) this.counterCurrent.textContent = idx + 1;

      const atStart = idx <= 0;
      const atEnd = this.list.scrollLeft + this.list.clientWidth >= this.list.scrollWidth - 1;

      if (this.prevButton) this.prevButton.toggleAttribute('disabled', atStart);
      if (this.nextButton) this.nextButton.toggleAttribute('disabled', atEnd);
    }
  }

  customElements.define('tk-slider', TkSlider);
}
